import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]

import {useId} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'secret',
  props: /*@__PURE__*/_mergeModels({
    title: {
      default: null,
      required: false,
      type: String
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: String
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  const id = useId()
  const value = _useModel(__props, "value")

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (__props.title)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _unref(id)
          }, _toDisplayString(__props.title), 9, _hoisted_1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        id: _unref(id),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        type: "password"
      }, null, 8, _hoisted_2), [
        [_vModelText, value.value]
      ])
    ]),
    _: 1
  }))
}
}

})